import React from 'react';

export default function EmailCapture({ variant = 'light' }) {
  function handleSubmit(event) {
    event.preventDefault();
  }

  return (
    <form className={`email-capture email-capture--${variant}`} onSubmit={handleSubmit} noValidate>
      <input
        type="email"
        name="email"
        autoComplete="email"
        placeholder="you@email.com"
        aria-label="Email address"
      />
      <button type="button" className={variant === 'dark' ? 'btn-cta' : 'btn-hero'}>
        Reserve a kit
      </button>
    </form>
  );
}
